import { xpTheme } from "../routes/xpTheme";
import { center, space18 } from "./helpers";

export default function ThemeWrapper({ 
  title, 
  cssUrl, 
  isDarkMode = true, 
  showSpace = true 
}) {
  return (
    <>
      {center(<h2>{title}</h2>)}
      <div>
        <link rel="stylesheet" href={cssUrl} />
        {xpTheme(isDarkMode)}
        {showSpace && space18}
      </div>
    </>
  );
}
